import {useEffect, useState} from 'react';
import {ActionMeta} from 'react-select';
import {toastApiErrors} from 'src/app/utilities/helpers/toast-api-errors';
import venuesService from 'src/data/services/venuesService';
import AsyncAutoComplete from 'src/view/components/auto-complete/AsyncAutoComplete';
import {
    AutoCompleteOption,
    AutoCompleteOptions,
    AutoCompleteValueOption,
} from 'src/view/components/auto-complete/interfaces';

interface Props {
    name: string;
    value?: AutoCompleteOption;
    onChange: (value: AutoCompleteValueOption, action?: ActionMeta<AutoCompleteOption>) => void;
    onCreateOption?: (name: string) => void;
    disabled?: boolean;
}

export default function VenueSelectDataWrapper({
                                                   name,
                                                   value,
                                                   onChange,
                                                   onCreateOption,
                                                   disabled,
                                               }: Props) {
    const [option, setOption] = useState<AutoCompleteOption | undefined>(value);

    useEffect(() => {
        setOption(value);
    }, [value]);

    const fetchVenueOptions = async (query: string): Promise<AutoCompleteOptions> => {
        if (disabled) return [];

        try {
            const res = await venuesService.getVenues({q: query});

            if (!res.data.data) return [];

            return res.data.data.map((o) => ({
                label: o.name,
                value: o.id,
                timeZone: o.address.timeZone ?? null,
            }));
        } catch (e) {
            toastApiErrors(e);

            return [];
        }
    };

    return (
        <AsyncAutoComplete
            name={name}
            value={option}
            loadOptions={fetchVenueOptions}
            onChange={onChange}
            placeholder={'select or create'}
            onCreateOption={onCreateOption}
            disabled={disabled}
        />
    );
}
